import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RightDrawerGuard } from './segment/right-drawer/right-drawer.guard';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { AuthGuard } from './user/auth.guard';


const guards = {
  canActivate: [AuthGuard],
  canActivateChild: [AuthGuard],
}

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'operations',
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
  },
  {
    path: 'operations',
    loadChildren: () => import('./operations/operations.module').then(m => m.OperationsModule),
    ...guards,
  },
  {
    path: 'segment',
    loadChildren: () => import('./segment/segment.module').then(m => m.SegmentModule),
    ...guards,
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
    ...guards,
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    ...guards,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // enableTracing: true,
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [RightDrawerGuard],
})
export class AppRoutingModule {}
